<form [formGroup]="form" autocomplete="off" class="form-horizontal m-1x mb-3x mt-3x">

  <div class="mb-5x">
    <common-ui-personenstamm-daten [(data)]="data.gesetzlicherVertreter"
                                   [readonly]="readonly"></common-ui-personenstamm-daten>
  </div>

  <div class="mb-5x">
    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.GESETZLICHER_VERTRETER.WEITERE_ANGABEN_GESETZLICHER_VERTETER.TITEL' | translate }}
    </h2>

    <common-ui-person-weitere-angaben [(data)]="data.gesetzlicherVertreterWeitereAngaben"
                                      [readonly]="readonly"></common-ui-person-weitere-angaben>

    <common-ui-steuernummer [(data)]="data.steuernummer" [readonly]="readonly"></common-ui-steuernummer>

    <div *ngIf="isKapGAus" class="form-row">
      <label class="col-sm-4 col-form-label"
             for="ustIdentifikationsnummer">{{ 'COMMON_UI.FRAGEBOGEN.GESETZLICHER_VERTRETER.USTID' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="ustIdentifikationsnummer{{objectId}}" formControlName="ustIdentifikationsnummer" id="ustIdentifikationsnummer"
               type="text" utilsCheckValidity
               utilsControlState utilsValidationMessage/>
      </div>
    </div>

  </div>

  <div class="mb-5x">
    <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ADRESSE.ADRESSE_TITEL' | translate }}</h2>
    <common-ui-adresserfassung [(auslandsadresse)]="data.auslandsadresse"
                               [(inlandsadresse)]="data.inlandsadresse"
                               [(postfachadresse)]="data.postfachadresse"
                               [readonly]="readonly"
                               [stammdatenAuslandsAdresse]="stammdaten?.auslandsadressen?.array"
                               [stammdatenInlandsadresse]="stammdaten?.inlandsadressen?.array" [stammdatenPostfachadresse]="stammdaten?.postfachadressen?.array">
    </common-ui-adresserfassung>
  </div>

  <div class="mb-5x">
    <h2 class="mb-3x">
      {{ 'COMMON_UI.FRAGEBOGEN.KOMMUNIKATIONSMITTEL.KOMMUNIKATIONSMITTEL_TITEL' | translate }}
    </h2>
    <common-ui-kommunikationsmittel
      [(data)]="data.kommunikationsmittel" [readonly]="readonly"
      [stammdatenInternetadressen]="stammdaten?.kommunikation?.internetadressen?.array"
      [stammdatenTelefonnummern]="stammdaten?.kommunikation?.telefonnummern?.array"
      maxTelefonnummern="2">
    </common-ui-kommunikationsmittel>
  </div>

</form>
